import { render, staticRenderFns } from "./location-editor.vue?vue&type=template&id=5d173b7a&scoped=true&"
import script from "./location-editor.vue?vue&type=script&lang=ts&"
export * from "./location-editor.vue?vue&type=script&lang=ts&"
import style0 from "./location-editor.vue?vue&type=style&index=0&id=5d173b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d173b7a",
  null
  
)

export default component.exports